var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.799 76.045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.305-53.213a2.114,2.114,0,0,0,.8-.232c5.932-2.869,8.042-4.658,8.042-8.286v-7.141a2.758,2.758,0,0,0-1.981-3.037c-.823-.347-4.362-1.48-5.1-1.7a6.518,6.518,0,0,0-1.763-.27,7.073,7.073,0,0,0-1.776.27c-.733.206-4.272,1.351-5.1,1.7a2.758,2.758,0,0,0-1.982,3.037v7.141c0,3.628,2.136,5.378,8.042,8.286A2.107,2.107,0,0,0,23.305-53.213ZM22.2-59.054a1.691,1.691,0,0,1-1.312-.682l-2.226-2.625a1.344,1.344,0,0,1-.4-.952,1.348,1.348,0,0,1,1.351-1.338,1.3,1.3,0,0,1,1.029.515l1.544,1.814,3.641-5.751a1.366,1.366,0,0,1,1.184-.772,1.328,1.328,0,0,1,1.377,1.287,1.618,1.618,0,0,1-.3.888L23.46-59.762A1.535,1.535,0,0,1,22.2-59.054Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.9746909abbcf1440a26d8e4c7ec03eb8.svg";
export { ForwardRef as ReactComponent };